import { useQuery } from 'react-admin';

function useGetAllWarehouseCompanyStatistic() {
    const {data = [], loading, loaded, error} = useQuery(
        {
            type: "all",
            resource: "warehousecompanies",
            payload: {
                sort: [{
                    field: "created_at",
                    order: "DESC",
                },{
                    field: "id",
                    order: "ASC",
                }],
            },
        },
        []
    );
    return {
        data, 
        loading, 
        loaded, 
        error,
    }
}

export default useGetAllWarehouseCompanyStatistic;
